/**
 * Organization: Revzoom India Pvt Ltd.
 * User: Sarthak
 * Date: 09-01-2017
 * Time: 5:36 PM
 */
export default class AbstractMap {
  constructor() {

  }

  /**
   * @param key {string|number}
   * @param value{*}
   */
  put(key, value) {
    throw new Error('Not implemented');
  }

  /**
   * @param key {string|number}
   * @return {*}
   */
  get(key) {
    throw new Error('Not implemented');
  }

  /**
   * @param key {string|number}
   * @return {boolean}
   */
  containsKey(key) {
    throw new Error('Not implemented');
  }

  /**
   * @param key {string|number}
   * @return {*}
   */
  remove(key) {
    throw new Error('Not implemented');
  }

  /**
   *
   * @param map {AbstractMap}
   */
  putAll(map) {
    throw new Error('Not implemented');
  }

  /**
   * @return {Array}
   */
  keys() {
    throw new Error('Not implemented');
  }

  /**
   * @return {Array}
   */
  values() {
    throw new Error('Not implemented');
  }

  /**
   * Removes all element.
   */
  clear() {
    throw new Error('Not implemented');
  }

  /**
   * @return {number}
   */
  size() {
    throw new Error('Not implemented');
  }

  /**
   * return {Array}
   */
  toArray() {
    throw new Error('Not implemented');
  }

  /**
   * @return {Iterator}
   */
  iterator() {
    throw new Error('Not implemented');
  }
}